// extracted by mini-css-extract-plugin
export default {"googleReviewStar":"GoogleReviewsRatingCount_googleReviewStar__jzC+9","totalReviewCount":"GoogleReviewsRatingCount_totalReviewCount__xYXRf"};